module.exports = __webpack_public_path__ + "media/images/covers/discover-your-future/discover-logo-2-9fab23f07f785ede79e22db2545f9d18.png";